export const START_FETCH = 'START_FETCH'
export const FETCH_SUCCESS = 'FETCH_SUCCESS'
export const ERROR_CATCHED = 'ERROR_CATCHED'
export const INPUT_EDIT = 'INPUT_EDIT'
